import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// MODULES
import accounts from './modules/accounts'
import analytics from './modules/analytics'
import apps from './modules/apps'
import auth from './modules/auth'
import banks from './modules/banks'
import billers from './modules/billers'
import dashboards from './modules/dashboards'
import generals from './modules/generals'
import global from './modules/global'
import customers from './modules/customers'
import invoices from './modules/invoices'
import orders from './modules/orders'
import subscriptions from './modules/subscriptions'
import payments from './modules/payments'
import reminders from './modules/reminders'
import purchases from './modules/purchases'
import suppliers from './modules/suppliers'
import bulks from './modules/bulks'
import supportingDocuments from './modules/supporting-documents'
import ui from './modules/ui'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: true,
  modules: {
    accounts,
    analytics,
    apps,
    auth,
    banks,
    billers,
    dashboards,
    generals,
    global,
    customers,
    invoices,
    orders,
    subscriptions,
    payments,
    reminders,
    purchases,
    suppliers,
    bulks,
    supportingDocuments,
    ui
  },
  plugins: [
    createPersistedState({
      paths: ['auth', 'ui']
    })
  ]
})
